import { createContext, useContext } from 'react';

/**
 * Which way the composer's menus open: up from a conversation's composer, at the bottom of its
 * pane; down from the start screen's, near the top of it. Every menu of one composer (+, the
 * model, the permissions, the project, the repository, the branch) opens the same way.
 */
export type ComposerMenuSide = 'top' | 'bottom';

const ComposerMenuSideContext = createContext<ComposerMenuSide>('top');

export const ComposerMenuSideProvider = ComposerMenuSideContext.Provider;

export function useComposerMenuSide(): ComposerMenuSide {
  return useContext(ComposerMenuSideContext);
}
